import { PartnerVoucher } from "../../services/partners";
import { partnersService } from "../../services/partners";

type RedeemArgs = {
  partnerId: string;
  voucher: PartnerVoucher;
  setRedeemingId: (id: string | null) => void;
  showToast: (message: string, type?: "success" | "error") => void;
  onUpdated: (updated: PartnerVoucher) => void;
};

export async function redeemIssuedVoucher({
  partnerId,
  voucher,
  setRedeemingId,
  showToast,
  onUpdated,
}: RedeemArgs): Promise<void> {
  if (voucher.status !== "issued") return;

  const confirmed = window.confirm(
    `Xác nhận đánh dấu voucher "${voucher.code}" đã được đổi tại nhà thuốc?`
  );
  if (!confirmed) return;

  try {
    setRedeemingId(voucher._id);
    const response = await partnersService.redeemPartnerVoucher(
      partnerId,
      voucher._id
    );
    onUpdated(response.data);
    showToast(`Voucher ${voucher.code} đã được đánh dấu đổi thành công`);
  } catch (err: any) {
    showToast(err.message || "Không thể đánh dấu đổi voucher", "error");
  } finally {
    setRedeemingId(null);
  }
}
